import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminHeader from '../../components/headers/AdminHeader';
import iconTitle from '../../assets/img/icon-square.svg';
import { deleteNotice, fetchAllNotices } from '../../services/api/NoticeService';
import { showSuccessDialog } from '../../providers/ErrorDialogProvider';
import '../../styles/NoticeList.css';
import '../../styles/button.css';
import { formatDateTimeForDisplay } from '../../utils/dateFormatter';

const NoticeList = () => {
  const navigate = useNavigate();
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadNotices = async () => {
    try {
      setLoading(true);
      const response = await fetchAllNotices();
      setNotices(Array.isArray(response) ? response : []);
    } catch (error) {
      setNotices([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadNotices();
  }, []);

  const handleNew = () => {
    navigate('/admin/notices/new');
  };

  const handleEdit = (notice) => {
    navigate(`/admin/notices/${notice.id}`, { state: { notice } });
  };

  const handleDelete = async (e, id) => {
    e.stopPropagation();

    const ok = window.confirm('このおしらせを削除します。よろしいですか？');
    if (!ok) return;

    try {
      await deleteNotice(id);
      showSuccessDialog('おしらせを削除しました。');
      await loadNotices();
    } catch (error) {
      // エラーダイアログ表示はBaseApiServiceで行う
    }
  };

  return (
    <div className="header-container-admin">
      <AdminHeader onMenuToggle={() => {}} />
      <div className="page-container">
        <div className="content-wrapper">
          <div className="notice-list-container">
            <div className="page-header">
              <div className="title-section">
                <div className="icon-square">
                  <img src={iconTitle} alt="icon" />
                </div>
                <h1>おしらせ一覧</h1>
              </div>
            </div>

            {loading ? (
              <div className="loading">読み込み中...</div>
            ) : (
              <div className="table-scroll-container">
                <table className="notice-table">
                  <thead>
                    <tr>
                      <th className='content-column'>タイトル</th>
                      <th className='content-column'>内容</th>
                      <th className='datetime-column'>公開開始日時</th>
                      <th className='datetime-column'>公開終了日時</th>
                      <th className='datetime-column'>通知開始日時</th>
                      <th className='datetime-column'>通知終了日時</th>
                      <th className='button-column'>&nbsp;</th>
                      <th className='button-column'>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    {notices.length > 0 ? (
                      notices.map((notice) => (
                        <tr key={notice.id} className="notice-row-clickable">
                          <td className="notice-content-cell">{notice.title || '-'}</td>
                          <td className="notice-content-cell">{notice.content || '-'}</td>
                          <td>{formatDateTimeForDisplay(notice.published_from)}</td>
                          <td>{formatDateTimeForDisplay(notice.published_to)}</td>
                          <td>{formatDateTimeForDisplay(notice.notice_from)}</td>
                          <td>{formatDateTimeForDisplay(notice.notice_to)}</td>
                          <td>
                            <button
                              type='button'
                              className="button button-primary btn-confirm-mini"
                              onClick={() => handleEdit(notice)}
                            >
                              編集
                            </button>
                          </td>
                          <td>
                            <button
                              type="button"
                              className="button button-secondary btn-confirm-mini white"
                              onClick={(e) => handleDelete(e, notice.id)}
                            >
                              削除
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="no-data">
                          データがありません
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          <div className="button-group button-group--mt-l c-justify-center">
            <button type="button" className="button button-secondary button-medium" onClick={() => navigate(-1)}>
              戻る
            </button>
            <button type="button" className="button button-primary button-medium" onClick={handleNew}>
              新規登録
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoticeList;